var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.adv ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Scenario')
    }
  })], 1) : _c('div', [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.adv.m_Title))]), _vm.adv.m_LibraryID != -1 ? [_c('p', {
    staticClass: "px-4 primary--text"
  }, [_vm.adv.m_ScriptTextName ? [_c('span', [_vm._v(_vm._s(_vm.$t('Section').format(parseInt(_vm.adv.m_ScriptTextName.slice(-2)))))]), _c('span', [_vm._v(" — ")])] : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.$name(_vm.$store.state.$db.ADVLibraryList[_vm.adv.m_LibraryID].m_ListName)))])], 2), _c('div', {
    staticClass: "px-4 mb-4"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.scenarios[_vm.index + 1]
    },
    on: {
      "click": function click($event) {
        return _vm.$router.replace("/scenario/".concat(_vm.scenarios[_vm.index + 1].m_AdvID));
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1), _c('div', [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.scenarios[_vm.index - 1]
    },
    on: {
      "click": function click($event) {
        return _vm.$router.replace("/scenario/".concat(_vm.scenarios[_vm.index - 1].m_AdvID));
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1)], 1)])] : _vm._e(), _c('v-divider'), this.cue && !_vm.voice_loaded ? _c('div', {
    staticClass: "py-4 text-center"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "text-end",
    attrs: {
      "cols": "5"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _c('v-col', {
    staticClass: "text-start",
    attrs: {
      "cols": "7"
    }
  }, [_c('div', {
    staticClass: "pt-2"
  }, [_vm._v(_vm._s(_vm.$t('Voice Loading')))])])], 1)], 1) : _vm._e(), !_vm.adv.m_ScriptTextName ? _c('div', {
    staticClass: "pa-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Scenario')
    }
  })], 1) : _vm.loading ? _c('div', {
    staticClass: "py-4 text-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : [_vm._l(_vm.text, function (item) {
    return _c('div', {
      key: "scenario-text-".concat(item.m_id)
    }, [_c('Item', {
      attrs: {
        "item": _vm.get_voice_injected_item(item),
        "show_voice": function show_voice() {
          return _vm.voice_loaded;
        }
      }
    })], 1);
  }), _c('v-divider'), _c('Ad', {
    key: "scenario-ad-".concat(_vm.id)
  }), _vm.adv.m_LibraryID != -1 ? [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.scenarios[_vm.index + 1]
    },
    on: {
      "click": function click($event) {
        return _vm.$router.replace("/scenario/".concat(_vm.scenarios[_vm.index + 1].m_AdvID));
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1), _c('div', [_c('v-btn', {
    attrs: {
      "icon": "",
      "disabled": !_vm.scenarios[_vm.index - 1]
    },
    on: {
      "click": function click($event) {
        return _vm.$router.replace("/scenario/".concat(_vm.scenarios[_vm.index - 1].m_AdvID));
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-left")])], 1)], 1)])] : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }